import React from 'react';
import { PromoIdentifier } from '@tvg/fuse/promo-identifier';
import styles from './PromotionIdentifier.module.css';

interface Props {
  text: string;
  colour: string;
  productIdentifierId: string;
}

function PromotionIdentifier({ text, colour, productIdentifierId }: Props) {
  const blackFridayLink = '/promo/black-friday-deals?numProducts=96';
  const content = (
    <PromoIdentifier size="xxs" className={styles.promoIdentifier} color={colour}>
      {text}
    </PromoIdentifier>
  );
  const BLACK_FRIDAY_PROMO_IDS = new Set([
    'very-black-friday-deal-identifier',
    'very-black-friday-new-deal-identifier',
    'very-black-friday-midnight-deal-identifier',
  ]);
  const isBlackFridayPromotion = !!(productIdentifierId && BLACK_FRIDAY_PROMO_IDS.has(productIdentifierId));

  return (
    <div className={styles.container} data-testid="promotion-identifier">
      {isBlackFridayPromotion ? (
        <a className={styles.clickableWrapper} data-transaction-name="BlackFridayPromotion" href={blackFridayLink}>
          {content}
        </a>
      ) : (
        content
      )}
    </div>
  );
}

export default PromotionIdentifier;
